
import { moldDto } from 'src/dtos/mold/moldDto';
import { formatDate } from 'src/utils/string/stringUtil';

export interface MST4040_R01Dto extends moldDto {
	itemNm?: string;
}

export const defaultMST4040_R01Dto: MST4040_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	moldCd: '',
	moldNm: '',
	moldType: '',
	moldClass: '',
	cavity: 0,
	purchaseAmt: 0,
	itemCd: '',
	itemNm: '',
	makerNm: '',
	makeDt: formatDate(new Date()),
	purchaseDt: formatDate(new Date()),
	shotLimit: 0,
	currentShot: 0,
	cleanCycle: 0,
	eqmstatus: '',
	useYn: '',
	moldImage: '',
	remark: '',

	inserted: false,
	isModified: false,
};
